import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Check, Phone, Calendar } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-28 pb-16 md:pt-36 md:pb-24 bg-slate-900 overflow-hidden" data-id="element-110">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-teal-900/20 rounded-full blur-3xl" data-id="element-111"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-blue-900/20 rounded-full blur-3xl" data-id="element-112"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-113">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-114">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center lg:text-left" data-id="element-115">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-116">
              {t('Weight-Loss Surgery Care in Allentown, PA', 'Cirugía bariátrica en Allentown, PA')}
            </h1>

            <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-117">
              {t('Maneesh Ailawadi, MD, FSSO — Expert General & Bariatric Surgeon at Lehigh Valley Weight Loss. Helping patients pursue better health with evidence-based surgical options.', 'Maneesh Ailawadi, MD, FSSO — Cirujano general y bariátrico en Lehigh Valley Weight Loss. Opciones quirúrgicas basadas en evidencia, con un plan claro y seguimiento.')}
            </p>

            <div className="space-y-3 mb-10 max-w-lg mx-auto lg:mx-0" data-id="element-118">
              {[t('Experienced bariatric & general surgeon', 'Experiencia en cirugía bariátrica y general'), t('Advanced training + research background', 'Formación avanzada e investigación'), t('Convenient Allentown location', 'Ubicación conveniente en Allentown')].map((item, index) => <div key={index} className="flex items-center justify-center lg:justify-start" data-id="element-119">
                  <div className="bg-teal-500/20 p-1 rounded-full mr-3" data-id="element-120">
                    <Check className="w-4 h-4 text-teal-400" data-id="element-121" />
                  </div>
                  <span className="text-slate-200 font-medium" data-id="element-122">{item}</span>
                </div>)}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-123">
              <button onClick={scrollToContact} className="inline-flex items-center justify-center px-8 py-4 bg-teal-600 hover:bg-teal-500 text-white font-bold rounded-lg transition-all shadow-lg hover:shadow-teal-500/25 text-lg" data-id="element-124">
                <Calendar className="w-5 h-5 mr-2" data-id="element-125" />
                {t('Schedule a Consultation', 'Agendar consulta')}
              </button>
              <a href="tel:4849341070" className="inline-flex items-center justify-center px-8 py-4 bg-transparent border-2 border-slate-600 hover:border-white text-white font-semibold rounded-lg transition-all hover:bg-white/5 text-lg" data-id="element-126">
                <Phone className="w-5 h-5 mr-2" data-id="element-127" />
                {t('Call 484-934-1070', 'Llamar al 484-934-1070')}
              </a>
            </div>

            <p className="mt-6 text-sm text-slate-400 italic" data-id="element-128">
              {t('Eligibility and treatment options are determined during a medical evaluation.', 'La elegibilidad y el plan se determinan con una evaluación médica.')}
            </p>
          </motion.div>

          {/* Doctor Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-1 relative" data-id="element-129">
            <div className="relative mx-auto w-72 h-72 sm:w-96 sm:h-96 lg:w-[450px] lg:h-[450px]" data-id="element-130">
              {/* Decorative ring */}
              <div className="absolute inset-0 rounded-full border-2 border-teal-500/30 transform rotate-6 scale-105" data-id="element-131"></div>
              <div className="absolute inset-0 rounded-full border-2 border-slate-700 transform -rotate-3 scale-110" data-id="element-132"></div>

              {/* Image container */}
              <div className="w-full h-full rounded-full overflow-hidden border-4 border-slate-800 shadow-2xl relative z-10 bg-slate-800" data-id="element-133">
                <img src="https://cdn.magicpatterns.com/uploads/5Rk82FQzqcVJkW3VxhvpdW/M-Ailawadi.jpg" alt="Dr. Maneesh Ailawadi" className="w-full h-full object-cover object-top" data-id="element-134" />
              </div>

              {/* Floating badge */}
              <div className="absolute bottom-4 right-4 sm:bottom-8 sm:right-8 z-20 bg-white p-3 sm:p-4 rounded-xl shadow-xl max-w-[160px] sm:max-w-[200px]" data-id="element-135">
                <p className="text-slate-900 font-bold text-sm sm:text-base leading-tight" data-id="element-136">
                  Dr. Maneesh Ailawadi
                </p>
                <p className="text-teal-600 text-xs sm:text-sm font-medium mt-1" data-id="element-137">
                  MD, FSSO
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}